export const endPoints = {
  CREATE_SCHOOL: "super-admin/create_school/",
  GET_SCHOOLS: "super-admin/get_schools/",
  UPDATE_SCHOOL: "super-admin/update_school/",
  GET_ALL_CURRICULUM: "super-admin/get_curriculums/",
  STATUS_UPDATE_SCHOOL: "super-admin/update_school_status/",
  CHANGE_SUPER_ADMIN_PASSWORD: "super-admin/super_admin_change_password/",
  SUPER_ADMIN_LOGIN: "super-admin/super_admin_login/",
  DELETE_SCHOOL: `super-admin/delete_school/`,
  SUPER_ADMIN_RESET_LINK: "super-admin/send_admin_reset_link/",
  SUPER_ADMIN_NEW_PASSWORD: "super-admin/set_admin_new_password/",
  SUPER_ADMIN_LOGOUT: "super-admin/super_admin_logout/",
  SUPER_ADMIN_CHANGE_SCHOOL_ADMIN_PASSWORD:
    "super-admin/super_admin_change_password/",

  //Dashboard APIs
  SUPER_ADMIN_DASHBOARD: "super-admin/super_admin_dashboard/",
  SCHOOL_ADMIN_DASHBOARD: "school-admin/school_admin_dashboard/",

  //Notifiication
  GET_NOTIFICATIONS: "assessment/get_notifications/",
  MARK_NOTIFICATION_READ: "assessment/mark_notification_read/",

  // SCHOOL ADMIN ENDPOINTS
  SCHOOL_ADMIN_LOGIN: "school-admin/school_admin_login/",
  SCHOOL_ADMIN_LOGOUT: "school-admin/school_admin_logout/",
  SCHOOL_ADMIN_FORGET_PASSWORD: "school-admin/school_forgot_password/",
  SCHOOL_ADMIN_RESET_PASSWORD: "school-admin/school_reset_password/",
  SCHOOL_ADMIN_OTP_VERIFY: "school -admin/school_verify_otp/",
  SCHOOL_ADMIN_CREATE_CLASS: "school-admin/create_or_update_class/",
  SCHOOL_ADMIN_CREATE_SECTION: "school-admin/create_section/",
  SCHOOL_ADMIN_CREATE_SESSION: "school-admin/create_or_update_sessions/",
  SCHOOL_ADMIN_GET_CLASS: "school-admin/get_classes/",
  SCHOOL_ADMIN_GET_SESSION: "school-admin/get_sessions/",
  SCHOOL_ADMIN_GET_SECTION: "school-admin/get_sections/",
  SCHOOL_ADMIN_UPDATE_CLASS: "school-admin/create_or_update_class/",
  SCHOOL_ADMIN_UPDATE_SECTION: "school-admin/update_section/",
  SCHOOL_ADMIN_UPDATE_SESSION: "school-admin/create_or_update_sessions/",
  SCHOOL_ADMIN_DELETE_CLASS: "school-admin/delete_class/",
  SCHOOL_ADMIN_DELETE_SECTION: "school-admin/delete_section/",
  SCHOOL_ADMIN_DELETE_SESSION: "school-admin/delete_session/",
  SCHOOL_ADMIN_CREATE_TEACHER: "teacher/create_teacher/",

  SCHOOL_ADMIN_CREATE_MAP_CLASS_SECTION:
    "school-admin/create_map_class_section/",
  SCHOOL_ADMIN_GET_MAP_CLASS_SECTION:
    "school-admin/get_mapped_classes_sections/",
  SCHOOL_ADMIN_GET_ALL_SUBJECT: "school-admin/school_admin_get_subjects/",

  // SUBJECT
  CREATE_UPDATE_SUBJECT: "school-admin/create_or_update_subject/",
  GET_SUBJECTS: "school-admin/get_subjects/",
  DELETE_SUBJECT: "school-admin/delete_subject/",

  // STUDENT
  SCHOOL_ADMIN_BULK_UPLOAD_VALIDATE: "school-admin/validate_bulk_students/",
  SCHOOL_ADMIN_BULK_UPLOAD_SAVE: "school-admin/save_bulk_students/",
  SCHOOL_ADMIN_GET_STUDENTS: "school-admin/get_students/",
  SCHOOL_ADMIN_ADD_UPDATE_STUDENT:
    "school-admin/create_or_update_single_student/",
  SCHOOL_ADMIN_DELETE_STUDENT: "school-admin/delete_student/",

  // TEACHER
  SCHOOL_ADMIN_CLASS_TEACHER_VALIDATION:
    "school-admin/class_teacher_validation/",
  SCHOOL_ADMIN_CREATE_MAP_CLASS_SECTION_TEACHER:
    "school-admin/assign_teacher_class_subjects/",
  SCHOOL_ADMIN_GET_TEACHER: "teacher/list_teachers/",
  SCHOOL_ADMIN_UPDATE_TEACHER: "teacher/update_teacher_details/",
  SCHOOL_ADMIN_DELETE_TEACHER: "teacher/delete_teacher/",
  TEACHER_LOGIN: "teacher/teacher_login/",
  TEACHER_LOGOUT: "teacher/teacher_logout/",
  TEACHER_DASHBOARD: "teacher/teacher_dashboard/",
  TEACHER_CONTENT_UPLOAD_WITH_UPDATE:
    "teacher/create_or_update_content_library/",
  GET_TEACHER_CONTENT_LIBRARY: "teacher/get_teacher_content_library/",
  TABLE_OF_CONTENT_DATA_EXTRATECT: "teacher/extract_toc_structure/",
  BULK_UPLOAD_TABLE_OF_CONTENT: "teacher/bulk_upload_ai_content/",
  TEACHER_UPDATE_MARKS: "teacher/update-marks/",

  //DELETE CONTENT
  DELETE_UPLOAD_CONTENT: "teacher/content/delete/",
  RESET_STRUCTURE_CONTENT_LIBRARY: "teacher/content/reset_structure/",
  DELETE_UPLOAD_FILE: "teacher/delete_content_file/",

  //QUESTION BANK
  CREATE_UPDATE_QUESTION_BANK: "assessment/add_or_update_questions/",
  GET_QUESTION_DETAIL_BY_ID: "assessment/get_question_detail_by_id/",
  DELETE_QUESTION_BANK: "assessment/delete_questions/",
  GET_QUESTION_BANK_ALL_QUESTIONS: "assessment/get_question_bank/",
  GENERATE_AI_QUESTIONS: "teacher/generate_ai_questions/",
  EXTRACT_OCR_QUESTIONS: "teacher/questions/extract_ocr/",
  AI_GENERATED_QUES_SAVE: "teacher/questions/save/",

  //Teacher-Assessment
  ADD_UPDATE_ASSIGNMENT: "assessment/add_update_assignment/",
  GET_ASSIGNMENTS_BY_TEACHER: "teacher/get_assignments/",
  GET_ASSIGNMENT_BY_ID: "teacher/get_assignments/",
  MAP_QUESTIONS_TO_ASSESMENT: "assessment/map_questions_to_assignment/",
  DELETE_ASSESMENT: "assessment/delete_assignment/",
  EXPORT_TO_EXCEL: "assessment/export_questions/",
  ASSIGNMENT_SUMMARY: "teacher/assignment-summary/",
  ASSIGNMENT_TEACHER_FEEDBACK: "teacher/feedback_create_update/",
  ASSIGNMENT_REVIEW_EXPORT_QUESTION: "teacher/export-questions/",
  ASSIGNMENT_REVIEW_EXPORT_STUDENT: "teacher/export-students/",

  // Help Center
  GET_HELP_CENTER_QUERIES: "teacher/get_help_requests/",
  RESOLVED_HELP_CENTER_QUERIES: "teacher/resolve_help_request/",

  // Change Password Api
  SCHOOL_ADMIN_CHANGE_PASSWORD: "school-admin/change_user_password/",
  TEACHER_CHANGE_PASSWORD: "teacher/change_password/",

  // Email Send Api
  SCHOOL_ADMIN_SEND_EMAIL: "school-admin/send_credentials_email_api/",

  // single teacher api
  SCHOOL_ADMIN_GET_SINGLE_TEACHER: "school-admin/get_teacher_by_id/",
};
